/**
 * @Description: vue config文件
 * @Author: jiangang
 * @Date: 2022-03-07
 * @LastEditTime: 15:02:09
 */
import router from '@/router';
import { Message } from 'nh-element-ui'
// import {mock} from '@/http'

const { menuList } = require('@/assets/data/menuList.js')
const state = {
  menuUpdateHook() {},
  maxTabs: 10,
  menuList: [],
  onTabClose: {},
  onTabClick: {},
  tabList: [],
  activeTab: {},
  // 页面形式tab或者breadcrumb
  navModel: 'breadcrumb',
  // 菜单折叠状态
  menuCollapse: 'collapse'
};

function updateRouter(array) {
  const currentPath = router.getRoutes().map(item => {
    return item.path
  })
  function doLoop(list) {
    list.forEach(item => {
      const page = {
        path: item.path,
        name: item.name,
        meta: {
          title: item.title,
          isFull: item.isFull,
          requireAuth: item.requireAuth !== false,
          keepAlive: !!item.keepAlive,
        }
      }
      const componentPath = item.component || item.path
      if (componentPath) {
        page.component = resolve => require([`@/views${componentPath}`], resolve)
      }
      if (page.path && !currentPath.includes(page.path)) {
        router.addRoute(page)
      }
      if (item.children && item.children.length) {
        doLoop(item.children)
      }
    })
  }
  doLoop(array)
}

const actions = {
  updateMenuList({ commit }, type = 'iot') {
    return new Promise((resolve) => {
      // 本地获取demo
      setTimeout(() => {
        commit('updateMenuList', menuList[type]);
        resolve(menuList[type])
      }, 1000)
      // if (process.env.NODE_ENV !== 'development') {
      //   // 本地获取demo
      //   setTimeout(() => {
      //     commit('updateMenuList', menuList[type]);
      //     resolve(menuList[type])
      //   }, 1000)
      // } else {
      //   // 远程请求demo
      //   mock.get('/menuList', {
      //     params: {
      //       type
      //     }
      //   }).then(res => {
      //     commit('updateMenuList', res);
      //     resolve(res)
      //   }).catch(err => {
      //     commit('updateMenuList', []);
      //     reject(err)
      //   })
      // }
    })
  },
  updateTabList({ commit }, list) {
    commit('updateTabList', list);
  },
  doSwitchTab({ commit }, item) {
    if (!item) {
      // 所有tab已关闭
      const path = router?.history?.current?.fullPath
      if (path !== '/wellcome') {
        router.replace('/wellcome')
      }
      // 清除已激活的tab
      commit('switchTab', {});
      return
    }
    const paths = state.tabList.map(menu => {
      return menu.path
    })
    // tab模式下，页面数量超过限制再开新页面时提示
    if (state.tabList.length >= state.maxTabs && !paths.includes(item.path) && state.navModel === 'tab') {
      Message({
        type: 'warning',
        showClose: true,
        message: '页面打开太多，为避免卡顿，请先关闭标签',
      })
    } else {
      commit('switchTab', item);
    }
  }
};

const mutations = {
  onTabClose(state, payload) {
    if (typeof payload === 'function') {
      state.onTabClose.common = payload
    } else {
      const {id, hook} = payload
      if (id && typeof hook === 'function') {
        state.onTabClose[id] = hook
      } else {
        console.error('参数必须为function或者{id, hook: function}')
      }
    }
  },
  onTabClick(state, payload) {
    // state.onTabClick[id] = hook
    if (typeof payload === 'function') {
      state.onTabClick.common = payload
    } else {
      const {id, hook} = payload
      if (id && typeof hook === 'function') {
        state.onTabClick[id] = hook
      } else {
        console.error('参数必须为function或者{id, hook: function}')
      }
    }
  },
  menuUpdateHook(state, hook) {
    state.menuUpdateHook = hook
  },
  updateMenuList(state, list) {
    // 部分操作需要在菜单初始化完成之后才能做，此处预留一个钩子函数
    if (typeof state.menuUpdateHook === 'function') {
      state.menuUpdateHook(list)
    }
    updateRouter(list)
    state.menuList = list
  },
  updateTabList(state, list) {
    state.tabList = [...list]
  },
  switchTab(state, item) {
    // 为了避免某些页面监听问题，页面跳转和tab显示各自分开做
    state.activeTab = {...item}
    // 更新已有的
    let include = false
    state.tabList = state.tabList.map(tab => {
      if (item.path === tab.path) {
        include = true
        return {
          ...tab,
          ...item
        }
      }
      return tab
    })
    if (!include && item?.path) {
      state.tabList.push(item)
    }
  },
  deleteTab(state, delItem) {
    state.tabList = state.tabList.filter(item => {
      return item.path !== delItem.path
    })
  },
  updateNavModel(state, val) {
    state.navModel = val
  },
  updateMenuCollapse(state, val) {
    state.menuCollapse = val
  }
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
